import { Component } from '@angular/core';
import { Subdivision, SubdivisionStatus } from 'src/shared/api';
import { FormConfig, CustomFormAccessor } from '../form-cva.component';
import { buildArrayFromEnum } from 'src/shared/utilities/utility-functions';
import { NgControl, FormBuilder } from '@angular/forms';

const subdivisionFormConfig: FormConfig<Required<Subdivision>> = {
	id: [''],
	name: [''],
	status: [SubdivisionStatus.Active],
	isAssignedToAJob: [''],
};

@Component({
	selector: 'rpshared-subdivision',
	templateUrl: './subdivision.component.html',
	styleUrls: ['./subdivision.component.css'],
})
export class SubdivisionComponent extends CustomFormAccessor<Subdivision> {
	// Constants
	readonly subdivisionStatuses = buildArrayFromEnum(SubdivisionStatus);

	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, subdivisionFormConfig);
	}

	// model --> view
	writeValue(value: Subdivision): void {
		super.writeValue(value);
	}

	// view --> model
	registerOnChange(fn: (value: Subdivision) => void) {
		super.registerOnChange(fn);
	}
}
